// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hvYMo","colBig":"styles_colBig__1keHU","colSmall":"styles_colSmall__6mr5J","shopifyNameWrapper":"styles_shopifyNameWrapper__1uOZ_"};